import { createEventDate } from "@anggunpraya-templates/base/app/utils/create-event-date";
import { defineClientConfig } from "@anggunpraya-templates/base/config/define-client-config";
import { defineAp004TemplateConfig } from "../app/schemas/template";

const weddingDate = createEventDate({
  // Tanggal pernikahan dalam format YYYY-MM-DD
  date: "2026-08-08",
  time: "09:00",
  timezone: "WITA",
});

const seoTheme = {
  colorScheme: "light",
  themeColor: "#505183",
} as const;

export const clientConfig = defineClientConfig({
  eventCode: "AP-20260804-9372",

  template: defineAp004TemplateConfig({
    general: {
      // Nama lengkap pengantin pria
      groom_name: "Ersan Karimi, S.Kom",
      // Nama panggilan pengantin pria
      groom_nickname: "Ersan",

      // Nama lengkap pengantin wanita
      bride_name: "Rani Windyan Nor, S.M",
      // Nama panggilan pengantin wanita
      bride_nickname: "Rani",

      date: weddingDate.iso,
      time: weddingDate.time,
      subdomain: "ersan-rani",
      initials: {
        groom: "E",
        bride: "R",
      },
      parents: {
        groom: {
          father: "Bapak Gusni Mahrani",
          mother: "Ibu Herni",
          order: "Pertama",
        },
        bride: {
          father: "Bapak Normansyah",
          mother: "Ibu Wahyuni",
          order: "Kedua",
        },
      },
    },

    others: {
      seo_theme: seoTheme,
      music: {
        enabled: true,
        src: "https://template.anggunpraya.id/audio/the-1975-about-you/the-1975-about-you.mp3",
      },
    },

    hero: {
      key: "hero",
      enabled: true,
      quotes: {
        text: "Dan segala sesuatu Kami ciptakan berpasang-pasangan agar kamu mengingat (kebesaran Allah)",
        source: "QS. Adz-Dzariyat: 49",
      },
    },

    events: {
      key: "events",
      enabled: true,
    },

    location: {
      key: "location",
      enabled: true,
      note: "Karena tempat acara memasuki area masjid harap ketersediaannya melepas alas kaki, tempat penyimpanan alas kaki telah disediakan.",
      items: [
        {
          activity: "Akad Nikah",
          venue: "Masjid Balikpapan Islamic Center",
          address: "Jl. Belibis, Gn. Bahagia, Kecamatan Balikpapan Selatan, Kota Balikpapan",
          maps_link: "https://maps.app.goo.gl/h3wAan1K6yQqJAd76",
          start_time: "09:00",
          timezone: "WITA",
          maps_embed_link: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3988.8865378437886!2d116.87989237578792!3d-1.238302635577242!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x2df1460d187fb791%3A0x5e15c021fdddf4cc!2sMasjid%20Madinatul%20Iman%20-%20Islamic%20Center%20Balikpapan!5e0!3m2!1sid!2sid!4v1781266719658!5m2!1sid!2sid",
        },
        {
          activity: "Walimatul ‘Ursy",
          venue: "Halaman Masjid Balikpapan Islamic Center",
          address: "Jl. Belibis, Gn. Bahagia, Kecamatan Balikpapan Selatan, Kota Balikpapan",
          maps_link: "https://maps.app.goo.gl/h3wAan1K6yQqJAd76",
          start_time: "11:00",
          end_time: "15:00",
          timezone: "WITA",
          maps_embed_link: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3988.8865378437886!2d116.87989237578792!3d-1.238302635577242!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x2df1460d187fb791%3A0x5e15c021fdddf4cc!2sMasjid%20Madinatul%20Iman%20-%20Islamic%20Center%20Balikpapan!5e0!3m2!1sid!2sid!4v1781266719658!5m2!1sid!2sid",
        },
      ],
    },

    gallery: {
      key: "gallery",
      enabled: false,
      imageCount: 0,
    },

    rsvp: {
      key: "rsvp",
      enabled: true,
    },

    dress_code: {
      key: "dress_code",
      enabled: false,
      color: "",
      style: "Formal",
      hex_colors: ["#475569", "#CBD5E1"],
    },

    gift: {
      key: "gift",
      enabled: true,
      bank_accounts: [
        {
          bank_name: "Bank Jago",
          account_name: "Ersan Karimi",
          account_number: "10********78",
          icon: "/bank-first.svg",
        },
      ],
    },

    wishes: {
      key: "wishes",
      enabled: true,
    },
  }),
});
